<template>
   <div v-drag.window-only class="reload-container">
       <div class="heading-section">
           <div class="update-message"><span class="update-msg">Update:</span> User</div>
           <div class="action-button-section">
               <span  class="btn btn-outline-secondary" style="border: 1px solid rgb(88, 88, 88);" @click="ignoreNdHidePanel()">{{$t('Ignore')}}</span>
               <span class="center-pipe"></span>
               <button  class="btn btn-outline-primary" @click="updateUserPrivilegeOrPermission()">{{$t('Reload')}}</button>
           </div>
       </div>
       <div class="content-section">
           <span>{{$t('Your Privilege(s)/Permission(s) has been updated, You need to reload to see the updated changes')}}.</span>
       </div>
   </div>
</template>

<script>
import {  mapActions } from "vuex";
import drag from '@branu-jp/v-drag';
// import {NotifierConstants} from "../../components.constants.js";

export default {
    props:["routePath","isAssetsGetRequired"],
   name:'ReloadPanel',
   directives: {
      drag
   },
   methods:{
     ignoreNdHidePanel(){
         this.$emit('hideReloadPanelComponent');
     },
/*      userPrivilegesOrPermissionUpdated(notification){
         console.log('notification',notification);
         if(notification && notification.message && notification.message._id == this.getLoggedInUserId){
             this.$emit('showReloadPanelComponent');
         } 
     }, */
     updateUserPrivilegeOrPermission(){
         this.updateLoggedInUserInfo().then((res) => {
             console.log('res',res);
             this.$store.commit('users/unsetUserinfo');
             this.$store.commit('users/setCurrentUserinfo',res.user);
             let parentinfo = this.routePath.matched[this.routePath.matched.length-1].parent?this.routePath.matched[this.routePath.matched.length-1].parent.name:this.routePath.matched[this.routePath.matched.length-1].name;
             if(parentinfo == 'settings'){
                return this.$emit('reloadSettingsMenu',this.routePath);
             }
             if(parentinfo == 'reports'){
                 return this.$emit('reloadReportsMenu', this.routePath);
             }
             this.$nextTick(()=>{
                 let registryUnsetList = [];
                 registryUnsetList = ['unSetBinContextMenu','unSetBinsMoreActionsContextMenu','unsetBinsNewActionsContextMenu']; //['unSetOverflowMenu','unSetSettingsSidemenu','unSetFloatingMenu','unSetBinContextMenu','unSetBinsMoreActionsContextMenu','unsetBinsNewActionsContextMenu','unSetPreferencesSidemenu','unSetReportsSideMenu','unSetSystemSettingsMenu','unsetPropertiesTopNav','unSetImportExportSettingsMenu'];
                for(let i = 0; i < registryUnsetList.length; i++){
                    try{
                        this.$store.commit(`registry/${registryUnsetList[i]}`);
                    }catch(e){console.log(e)}
                }
             });
            this.fetchUserPrefferedLanguage().then((data)=>{
                if(!('mapper' in data)){
                return
                }
                this.languageMapper = data.mapper;

                //  if(data.code == 'en'){
                //       this.languageMapper = {};    
                //     }else{
                //       this.languageMapper = data.mapper;
                //     }
             
                this.$set(this.$i18n, "locale", data.code)
                this.$set(this.$i18n, "locale_name", data.name)
                this.$set(this.$i18n, "orientation", data.orientation)
                this.$i18n.setLocaleMessage(data.code, this.languageMapper);

                this.$nextTick(()=>{
                    document.documentElement.setAttribute('lang', data.code);
                    document.documentElement.setAttribute('dir', data.orientation);
                });

                console.log("check language mapper.............",  data, (this.$i18n.messages.kn));
            }); 
            this.$emit('reloadFusionUponPrivUpdate',this.routePath,this.isAssetsGetRequired)
            // this.$nextTick(() => {
            //     setTimeout(() => {
            //          this.$emit('setupcontextmenuaction');
            //     },500);
               
            // });
      
            //     this.$nextTick(() => {
            //        setTimeout(() => {
            //           this.$emit('hideReloadPanelComponent');
            //           this.$toast.success('Updated Sucessfully.');
            //        },700)
            //     });
             
          });
     },
     ...mapActions("users",["updateLoggedInUserInfo"]),
     ...mapActions("language", ["fetchUserPrefferedLanguage"])
   },

   computed:{
    getUserPreferedLanguageDetails:{
        get(){
            return this.$store.state.language.languageUserPrefered;
        }
    },
   },
/*    mounted(){
       this.addWSEventListener({eventname:NotifierConstants.userUpdatedNotification,callback:this.userPrivilegesOrPermissionUpdated,parent:"ReloadPanel"});
   } */
}
</script>

<style lang="scss" scoped>
$bg-color-on-hover: #22272b;
$secondary-border-color: 1px solid #2b2b2b;
$dull-text-color: #858585;
$info-color:rgb(209, 210, 211);
$info-font-size:15px;

.reload-container{
    border-top: $secondary-border-color;
    background: $bg-color-on-hover;
    box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    padding: 4px;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    min-width: 357px;
    width:auto;
    position: fixed;
    bottom: 16px;
    z-index: 99999;
    inset-inline-start: 26px;
    max-width:460px;
    max-height: fit-content;
    text-align: start;
    padding-inline-start: 12px;
    padding-bottom: 13px;
    padding-inline-end: 12px;
}
.heading-section{
    display: flex;
    align-items: center;
    margin:12px 0px;
}
.update-message{
   flex-basis: 37%;
}
.action-button-section{
    flex: 1;
    text-align: end;
}
.center-pipe{
    display: inline-flex;
    width: 28px;
    position: relative;
    text-align: center;
    justify-content: center;
    align-items: center;
}
.center-pipe::before{
    position: absolute;
    content: "";
    // top: 0;
    // inset-inline-start: 0;
    width: 1px;
    height: 37px;
    background: #373737;
    transform: translate(0px, -3px);
    // transform: translate(11px,-23px);
}
.content-section{
    color: $info-color;
    // font-size: $info-font-size;
}
.update-msg{
    color: $dull-text-color;
}
</style>